import React, { useEffect } from 'react';
import ReactGA from "react-ga4";
import PageTopBanner from '../components/PageTopBanner';
import FormationCards from '../components/FormationCards';
import { formationsData } from '../data/formationsData';
import { contentData } from '../data/contentData';
import ReassuranceBanner from '../components/ReassuranceBanner';
import '../style/pages/_nosFormations.scss';

const NosFormations = () => {
    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: "/nos-formations",
            title: "Nos Formations",
        });
    });

    const selectedContent = contentData.find((content) => content.id === 4);

    return (
        <div>

            <main>
                <PageTopBanner
                    img={selectedContent.img}
                    title={selectedContent.title}
                    info={selectedContent.info}
                />

                <div className="o3academie-container">
                    <h2 className="courses-presentation">Découvrez nos formations certifiées Qualiopi, structurées pour répondre aux besoins spécifiques de chaque apprenant</h2>

                    <section className="courses-list">
                        <FormationCards formations={formationsData} />
                    </section>
                </div>

                <ReassuranceBanner />

            </main>

        </div>
    );
};

export default NosFormations;